import React from 'react';
import { RouteObject } from 'react-router';

const ShopeeAuthorizationCompletePage = React.lazy(() =>
  import('./pages/complete').then((module) => ({
    default: module.ShopeeAuthorizationCompletePage,
  }))
);

/**
 * Mounted as a sibling of the `<App />` route rather than a child of it (anyx#1705).
 *
 * A child would render inside `AppLayout`, so a merchant who has never heard of AnyX would land on
 * their "authorization complete" message wrapped in our sidenav and footer. It would also mount the
 * whole provider stack — Auth0, Apollo, workspace — for a page that must reach none of it. An
 * unguarded sibling gets neither the chrome nor the providers.
 *
 * The static `shopee-authorization` segment outranks the sibling `:workspaceMasterStoreDataId?/`
 * route, which is what keeps this reachable; `app.routing.spec.tsx` pins that so a future router
 * change cannot silently swallow the path.
 */
export const routes: RouteObject[] = [
  {
    path: 'shopee-authorization',
    children: [
      {
        path: 'complete',
        element: <ShopeeAuthorizationCompletePage />,
      },
    ],
  },
];
